import { createSlice } from "@reduxjs/toolkit";
import { EditParticipantsState } from "../../types";

const initialState: EditParticipantsState = {
  selectedParticipants: [],
  selectedFromWaitingList: [],
  signupSuccessfull: false,
  reassignParticipantsSuccess: false,
  participants: []
};

export const editParticipantsSlice = createSlice({
  name: "editParticipants",
  initialState,
  reducers: {
    getParticipantsSuccess(state: EditParticipantsState, action: any) {
      state.participants = action.payload;
    },
    editSelectedParticipants(state: EditParticipantsState, action: any) {
      state.selectedParticipants = action.payload;
    },
    editSelectedFromWaitingList(state: EditParticipantsState, action: any) {
      state.selectedFromWaitingList = action.payload;
    },
    signupForEventSuccess(state: EditParticipantsState) {
      state.signupSuccessfull = true;
    },
    setSignupSuccessfull(state: EditParticipantsState, action: any) {
      state.signupSuccessfull = action.payload;
    },
    reset() {
      return initialState;
    }
  }
});

const { reducer } = editParticipantsSlice;

export default reducer;
